import { render } from "./myorder.vue?vue&type=template&id=56f4a8b6&scoped=true"
import script from "./myorder.vue?vue&type=script&lang=js"
export * from "./myorder.vue?vue&type=script&lang=js"

import "./myorder.vue?vue&type=style&index=0&id=56f4a8b6&lang=scss&scoped=true"

import exportComponent from "F:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f4a8b6"]])

export default __exports__